/*
	日期：2025/08/25
	地点：四川 成都
	作者：终结司令官
	
	介绍：HTTP:GET/POST 数据请求
	
	- Powered by finalcommander.com
	- Supported by IOE.TOP
*/

// 引入全局工具函数
import { globalUtils, constants, defaultConfig } from '../utils/globalUtils'

import http_req from '../utils/request.js'
import { func_readapi_jj } from '../utils/function.js'
import Cookies from 'js-cookie'

export const getDownloadURL = (obj,domainname=null) => {
	if(domainname === null) domainname = globalUtils.getBaseUrl(true,false,false,3);
	let download_url = "";
	if(obj)
	if(obj.localpath && obj.name)
	{
		if(/^https?:\/\//.test(domainname))
		{
			download_url = domainname
				+ "/download/file/cdn/01/"
				+ "/l/" + obj.localpath
				+ "/f/" + obj.name;
		}
		else
		{
			download_url =window.location.protocol + "//" + domainname
				+ "/download/file/cdn/01/"
				+ "/l/" + obj.localpath
				+ "/f/" + obj.name;
		}
	}
	return download_url;
}

export const getImageURL = (path,domainname=null) => {
	if(domainname === null) domainname = globalUtils.getBaseUrl(true,false,false,3);
	let download_url = "";
	if(path)
	{
		if(/^https?:\/\//.test(domainname))
		{
			download_url = domainname
				+ "/uploadfiles/"
				+ path;
		}
		else
		{
			download_url =window.location.protocol + "//" + domainname
				+ "/uploadfiles/"
				+ path;
		}
	}
	return download_url;
}

// 请求首页数据接口
export const getData = () => {
	// 会返回一个 promise 对象
	let res = http_req.get('/getData/');
	//console.log(res);
	return res;
}

// 请求用户列表
export const getUserList = (params) => {
	// 会返回一个 promise 对象
	let res = http_req.get('/user/list/',params);
	//console.log(res);
	return res;
}

// 添加用户
export const createUser = (data) => {
	// 会返回一个 promise 对象
	let res = http_req.post('/user/create/',data);
	//console.log(res);
	return res;
}

// 删除用户
export const deleteUser = (data) => {
	// 会返回一个 promise 对象
	let res = http_req.post('/user/delete/',data);
	//console.log(res);
	return res;
}

// 修改用户
export const updateUser = (data) => {
	// 会返回一个 promise 对象
	let res = http_req.post('/user/update/',data );
	//console.log(res);
	return res;
}

// 用户登陆验证
export const loginUser = (data) => {
	// data.username = "test"
	// data.password = "password"
	return func_readapi_jj("/login/user/",data);
}

// 用户登陆验证
export const loginUserWX = (data) => {
	// data.username = "test"
	// data.password = "password"
	return func_readapi_jj("/login/wx/",data);
}

/*
// 获得登陆用户信息
export const getCurInfo = () => {
	// 读取本次登陆信息
	const curUserLogin = Cookies.get('curUserLogin');
	// 是否正确读取
	if (curUserLogin) {
		try {
			// 解析用户信息
			const u = JSON.parse(curUserLogin);
			return u;
		} catch (e) {
			// 解析用户信息失败
			console.error('解析用户信息失败', e);
			return false;
		}
	}
	// 验证失败
	return false;
};

// 验证登陆状态
export const fun_is_online = () => {
	try {
		// 解析用户信息
		const u = getCurInfo();
		// 发送校验西悉尼
		return {
			username: u.username,
			at: u.at
		};
	} catch (e) {
		// 解析用户信息失败
		console.error('解析用户信息失败', e);
		return false;
	}
};
*/

// 验证登陆状态
export const get_username_at = () => {
	// 验证登陆状态
	let u = globalUtils.fun_is_online();
	let ua = 'u/' + u.username + "/a/" + u.at;
	//console.log(ua);
	return ua;
};

// 用户登陆退出
export const logoutUser = (data) => {
	// 验证登陆状态
	let u = globalUtils.fun_is_online();

	Cookies.remove('curUserLogin');
	localStorage.removeItem('curUserMenu');
					
	if (u) {
		// 退出登陆
		let jres = func_readapi_jj("/login/off/",data);
		return jres;
	} else {
		// 未登录
		return false;
	}
}

// 直接调用API指令，通过POST验证身份
export const getQuery = (cmd,val,data) => {
	// 验证登陆状态
	let u = globalUtils.fun_is_online();
	//console.log("u",u);
	
	// 格式强制处理
	if(typeof(data)!="object") data = {};
	
	// 如果验证登陆状态成功
	if (u) {
		// 发送用户名和登陆验证吗
		data.username = u.username;
		data.at =  u.at;
		
		// 执行服务端指令并返回数据
		let res =  func_readapi_jj("/" + cmd + "/" + val + "/",data);
		
		//// 调试使用 ////
		if(res.code && res.data && res.message)
		{
			res.data.code = res.code;
			
			if(res.code == 20000)
			{
				return res.data;
			}
			else if(res.code == -10000)
			{
				//alert('登陆超时，请重新进入系统！');
				logoutUser(data);
				location.href = "/?TIMEOUT=LOGIN";
				return res.data;
			}
			else
			{
				console.error("res:", res);
			}
		}
		else
		{
			// 退出登陆
			//logoutUser(data);
			console.error("res:", res);
		}
		return false;
	}
	// 如果验证登陆状态失败
	else
	{
		// 退出登陆
		logoutUser(data);
		return false;
	}
}


// 直接调用API指令，不验证身份
export const getQueryNull = (cmd,val,data) => {
	// 验证登陆状态
	let u = true;
	
	// 格式强制处理
	if(typeof(data)!="object") data = {};
	
	// 如果验证登陆状态成功
	if (u) {
		// 发送用户名和登陆验证吗
		data.username = u.username;
		data.at =  u.at;
		
		// 执行服务端指令并返回数据
		let res =  func_readapi_jj("/" + cmd + "/" + val + "/",data);
		
		//// 调试使用 ////
		if(res.code && res.data && res.message)
		{
			res.data.code = res.code;
			
			if(res.code == 20000)
			{
				return res.data;
			}
			else if(res.code == -10000)
			{
				//alert('登陆超时，请重新进入系统！');
				logoutUser(data);
				location.href = "/?TIMEOUT=LOGIN";
				return res.data;
			}
			else
			{
				console.error("res:", res);
			}
		}
		else
		{
			// 退出登陆
			//logoutUser(data);
			console.error("res:", res);
		}
		return false;
	}
	// 如果验证登陆状态失败
	else
	{
		// 退出登陆
		logoutUser(data);
		return false;
	}
}

// 直接调用API指令，通过URL身份验证
export const getpQuery = (cmd,val,data) => {
	// 验证登陆状态
	let u = globalUtils.fun_is_online();
	
	// 格式强制处理
	if(typeof(data)!="object") data = {};
	
	// 如果验证登陆状态成功
	if (u) {
		// 发送用户名和登陆验证吗
		//data.username = u.username;
		//data.at =  u.at;
		
		// 执行服务端指令并返回数据
		let res =  func_readapi_jj("/" + cmd + "/" + val + "/u/" + u.username + "/a/" + u.at + "/",data);
		//console.log("res:", res);
		if(res.code && res.data)
		{
			if(res.code == 20000)
			{
				return res.data;
			}
			else
			{
				console.error("res:", res);
			}
		}
		else
		{
			console.error("res:", res);
		}
		
		return false;
	}
	// 如果验证登陆状态失败
	else
	{
		// 退出登陆
		logoutUser(data);
		return false;
	}
}

// 用户登陆验证
export const loginWXUser = (type, at="", from="") => {
	from = localStorage.getItem('from');
	if(!at || at ==="null" || at ===null || at==="")
	{
		let autop = "false";
		
		if(Cookies.get('selLoginOption') === "true")
		{
			autop = "true";
		}
		
		const { protocol, hostname, port, pathname } = window.location;
			
		const url = globalUtils.getBaseUrl(true,false,false,2) + "/gd/z/x/" + hostname + "/login/p/" 
			+ window.location.protocol + "/auto/" + autop + "/for/" + type
			+ "/from/" + from;

		location.href = url;
	}
	else
	{
	}
}
		